import region from '@/utils/region'

export default {
    name: 'FormItem',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        type: {
            type: String,
            required: true
        },
        value: {
            required: true
        },
        options: {

        },
        filterable: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: String,
        props: {
            type: Object,
            default(){
                return {}
            }
        },
        pickerOptions: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    data(){
        return {
            defaultValue: ''
        }
    },
    computed: {
        valueCpd: {
            get(){
                return this.value
            },
            set(val){
                if(val === null && this.type === 'dateTimeRange'){
                    val = []
                }else if(val === null && this.type === 'dateRange'){
                    val = []
                }else if(val === null && this.type === 'month'){
                    val = ''
                }else if(val === null && this.type === 'monthRange'){
                    val = []
                }else if(this.type === 'dateTimeRange' && val.length){
                    val = val.map(item => item.slice(0, 16))
                }
                this.$emit('change', val)
            }
        },
        region(){
            var regionData = JSON.parse(JSON.stringify(region))
            regionData.forEach(province => {
                province.list.forEach(city => {
                    delete city.list
                })
            })
            return regionData
        }
    },
    created(){
        this.defaultValue = (typeof(this.value) == 'object' && this.value !== null) ? JSON.parse(JSON.stringify(this.value)) : this.value
    },
    mounted(){
        if(this.type === 'input'){
            let oInput = this.$refs.input.$el.getElementsByTagName('input')
            if(oInput.length > 0){
                oInput[0].addEventListener('keyup', (e) => {
                    if(e.keyCode == 13){
                        this.$emit('enter', this.value)
                    }
                })
            }
        }else if(this.type === 'select' || this.type === 'dateAndTimeRanges'){
            this.selectInput = this.$refs.select.$el.querySelector('.el-input__inner')
            this.selectInput.removeAttribute('readonly')
        }
    },
    methods: {
        revertValue(){
            this.$emit('change', (typeof(this.defaultValue) == 'object' && this.defaultValue !== null) ? JSON.parse(JSON.stringify(this.defaultValue)) : this.defaultValue)
        },
        visibleChange(flag){
            if(!flag){
                this.selectInput.blur()
                this.$nextTick(() => {
                    this.selectInput.removeAttribute('readonly')
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/FormItem/FormItem.js